import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1780f952")
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "texts p-col-6" }
const _hoisted_3 = { class: "p-col-12 p-p-0" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre de la empresa", -1)
const _hoisted_6 = { class: "p-field p-col-12 p-d-flex p-flex-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "file" }, "Logo de la empresa (SVG)", -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "accionables p-col-6" }
const _hoisted_10 = { class: "form-field flex items-center p-mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "labels w-32" }, "Categorías", -1)
const _hoisted_12 = { class: "form-field flex items-center p-mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "labels w-32" }, "Certifica", -1)
const _hoisted_14 = { class: "form-field flex items-center p-mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "labels w-32" }, "Cobrandea", -1)
const _hoisted_16 = { class: "form-field flex items-center p-mb-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-3 labels",
  for: "description"
}, "Descripcion", -1)
const _hoisted_18 = { class: "form-field flex items-center p-mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-3 labels",
  for: "description"
}, "Url", -1)
const _hoisted_20 = { class: "p-field p-col-12 brand-country-selector" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "countries" }, "No se muestra en (Países)", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Editor de Empresas",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.visible = $event)),
    style: {'max-width': '95vw'},
    closeOnEscape: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Cancelar",
        icon: "pi pi-times",
        onClick: _ctx.closeEditDialog,
        class: "p-button-text "
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Guardar",
        icon: "pi pi-check",
        onClick: _ctx.onSave,
        disabled: !_ctx.isValidData,
        class: ""
      }, null, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                id: "brand-name",
                type: "text",
                modelValue: _ctx.editableBrand.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.editableBrand.name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_FileUpload, {
                class: "ch-fileupload",
                name: "file",
                mode: "basic",
                accept: "image/svg+xml",
                chooseLabel: "Agregar/Editar",
                customUpload: true,
                auto: true,
                onUploader: _ctx.onUpload,
                onUpload: _ctx.onUploaded
              }, null, 8, ["onUploader", "onUpload"]),
              (_ctx.editableBrand.logoUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "logo-img",
                    src: _ctx.editableBrand.logoUrl,
                    alt: ""
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_MultiSelect, {
              class: "ch-w100 flex-grow p-mt-2",
              modelValue: _ctx.editableBrand.categories,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editableBrand.categories = $event)),
              options: _ctx.categories,
              optionLabel: "name",
              optionValue: "key",
              display: "chip",
              placeholder: "Seleccionar Categorías"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_MultiSelect, {
              class: "ch-w100 flex-grow p-mt-2",
              modelValue: _ctx.editableBrand.certifiesProducts,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editableBrand.certifiesProducts = $event)),
              options: _ctx.products,
              optionLabel: "title",
              optionValue: "_id",
              "data-key": "_id",
              display: "chip",
              filter: true,
              placeholder: "Seleccionar Productos"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_MultiSelect, {
              class: "ch-w100 flex-grow p-mt-2",
              modelValue: _ctx.editableBrand.cobrandsProducts,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editableBrand.cobrandsProducts = $event)),
              options: _ctx.products,
              optionLabel: "title",
              optionValue: "_id",
              "data-key": "_id",
              display: "chip",
              filter: true,
              placeholder: "Seleccionar Productos"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_InputText, {
              class: "p-mt-2",
              id: "brand-description",
              type: "text",
              modelValue: _ctx.editableBrand.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editableBrand.description = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_InputText, {
              class: "p-mt-2",
              id: "brand-url",
              type: "text",
              modelValue: _ctx.editableBrand.url,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editableBrand.url = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _hoisted_21,
            _createVNode(_component_CountrySelector, {
              modelValue: _ctx.editableBrand.hiddenOnCountries,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editableBrand.hiddenOnCountries = $event)),
              multiple: true,
              optionValue: "id"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}